// Function to play notification sound
export const playSound = (filename) => {
  // For web preview, try MP3 first, then AIFF as fallback
  const mp3File = "notif_" + filename.replace('.aiff', '.mp3').toLowerCase().replace(" ", "");
  const audio = new Audio(`/sounds/${mp3File}`);
  audio.play().catch(error => {
    // Fallback to AIFF if MP3 fails
    const aiffAudio = new Audio(`/sounds/${filename}`);
    aiffAudio.play().catch(fallbackError => {
      console.warn('Could not play sound:', fallbackError);
    });
  });
};
